import { Popover } from '@sravni/react-design-system';
import type { Placement } from '@sravni/react-design-system/dist/types/types/Placements.types';
import { useBoolean } from '@sravni/react-utils';
import type { FC, ReactNode } from 'react';
import React from 'react';

import styles from './AdaptivePopover.module.scss';

type Props = {
  content: ReactNode;
  placement?: Placement;
};

export const AdaptivePopover: FC<Props> = ({ children, content, placement }) => {
  const [isVisible, setIsVisible] = useBoolean(false);

  return (
    <Popover
      className={styles.popover}
      visible={isVisible}
      onClose={setIsVisible.off}
      positionerSettings={{
        placement,
        flip: false,
        matchWidth: true,
      }}
      content={content}
    >
      <div onClick={setIsVisible.on}>{children}</div>
    </Popover>
  );
};
